import comparisonStep from '@/router/steps/comparison';
import completionStep from '@/router/steps/completion';
import contractStep from '@/router/steps/contract';
import inputStep from '@/router/steps/input';
import offersStep from '@/router/steps/offers';
import type { StepConfig } from '@/router/types';

/**
 * Represents the steps of the wizard / step component shown
 */
export enum STEP {
  COMPLETION = 'completion',
  INPUT = 'input',
  OFFERS = 'offers',
  COMPARISON = 'comparison',
  CONTRACT = 'contract',
}

/**
 * Extra Step for setting up distribution
 * Not enabled in every Sparte
 */
export enum DISTRIBUTION_STEP {
  SELECT = 'select-distribution',
}

/**
 * Array of valid step values
 */
export const validSteps = Object.values(STEP);

/**
 * List of valid stepper step configurations.
 * Each contains the default config of that step for the router and wizard.
 */
export const stepperStepConfig: Record<STEP, StepConfig> = {
  // WARNING: Do not change the order of this in any way,
  // they're ordered by their appearance in the wizard
  [STEP.INPUT]: inputStep,
  [STEP.OFFERS]: offersStep,
  [STEP.COMPARISON]: comparisonStep,
  [STEP.CONTRACT]: contractStep,
  [STEP.COMPLETION]: completionStep,
};
